'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserMetaData = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @function getUserMetaData
 *
 * @description
 * Makes a request to the user-metadata API endpoint on Janus to retrieve user metadata.
 * This function sends a GET request to the `/api/user-metadata/` endpoint from Janus.
 *
 * @example For local testing:
 * await fetch('http://localhost:8080/api/user-metadata/?userId=${userId}')
 *
 * @returns {Promise<void>} A promise that resolves when the user metadata is successfully fetched.
 */
var getUserMetaData = exports.getUserMetaData = function getUserMetaData(userIdLocal) {
    if (!userIdLocal) return;

    if (!global.analytics || !global.analytics.initialize) return;

    setTimeout((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/user-metadata/?userId=' + userIdLocal).then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            /* eslint-disable no-console */
                            console.log('Success get the user meta data', data);
                        }).catch(function (error) {
                            /* eslint-disable no-console */
                            console.log('There was an error fetching user meta data', error);
                        });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    })), 1000);
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/utils/getUserMetaData.js
// module id = 2677
// module chunks = 0